// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"ebb2fc79","213":"e8ba6d71","453":"a7849a56","455":"346a1991","514":"a443779d","652":"f993bfe2"}[chunkId] + ".chunk.js";
};